import { Tooltip } from '@audio-network/componentlibrary'
import { ChevronDown, ChevronUp } from '@audio-network/componentlibrary/icons'
import clsx from 'clsx'
import React, { memo, useRef } from 'react'

import styles from './FilterButton.module.css'
import { FilterButtonProps, WrapperComponentProps } from './FilterButton.types'

// Will wrap the button in a tooltip if the button is too narrow to display the title
const WrapperComponent = memo(
	({
		children,
		expanded,
		title,
		requiresTooltip,
	}: WrapperComponentProps): JSX.Element => {
		if (requiresTooltip) {
			return (
				<Tooltip content={title} className={expanded && styles.hidden}>
					{children}
				</Tooltip>
			)
		}
		return <>{children}</>
	}
)

WrapperComponent.displayName = 'FilterButtonWrapper'

const FilterButton = ({
	'aria-expanded': expanded,
	className,
	Icon,
	onClick,
	mobile,
	primary,
	secondary,
	role,
	title,
	...props
}: FilterButtonProps): JSX.Element => {
	const wrapperRef = useRef<HTMLDivElement>(null)
	const topLevelButton = !!((primary || secondary) && !mobile)
	const requiresTooltip = topLevelButton

	return (
		<div ref={wrapperRef}>
			<WrapperComponent
				title={title}
				expanded={expanded === true}
				requiresTooltip={requiresTooltip}
			>
				<button
					aria-expanded={expanded}
					className={clsx(
						styles.filterButton,
						primary && styles.primary,
						className
					)}
					onClick={onClick}
					role={role}
					{...props}
				>
					{Icon && Icon}
					<span className={styles.title}>{title}</span>
					{expanded ? (
						<ChevronUp className={styles.chevron} />
					) : (
						<ChevronDown className={styles.chevron} />
					)}
				</button>
			</WrapperComponent>
		</div>
	)
}

export default FilterButton
